module.exports = __webpack_public_path__ + "img/boiler_install.8abca43c.png";